import type { ReactNode } from "react";
import styled from "styled-components";
import { Card } from "./Card";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Box = styled(Card)`
  flex: 1;
  min-width: 140px;
  padding: ${spacing.x2}px ${spacing.x3}px;
`;

const Label = styled.div`
  font-size: ${fontSizes.small}px;
  color: ${colors.textMuted};
  margin-bottom: ${spacing.x1}px;
`;

const Value = styled.div`
  font-size: ${fontSizes.xlarge}px;
  font-weight: 700;
  color: ${colors.text};
`;

const Footer = styled.div`
  margin-top: ${spacing.x1}px;
  font-size: ${fontSizes.small}px;
  color: ${colors.textMuted};
`;

interface StatBoxProps {
  label: string;
  value: string | number;
  footer?: ReactNode;
}

export const StatBox = ({ label, value, footer }: StatBoxProps) => (
  <Box>
    <Label>{label}</Label>
    <Value>{value}</Value>
    {footer && <Footer>{footer}</Footer>}
  </Box>
);
